<template>
    <div class="info-location">
        <h3 class="cont-tit">위치정보</h3>
        <div class="map-location">
            <div id="map" style="width:100%; height:400px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lat: { type: Number, default: 37.3595316 },
        lng: { type: Number, default: 127.1052133 },
        addresses: { type: String },
        baseInfo: { type: Object, default: function(){
            return { addr1: "" }
        }}
    },
    mounted() {
        setTimeout(t=>{
            this.initNaverMap();
        }, 100);
    },
    updated(){
        this.initNaverMap();
    },
    methods: {
        initNaverMap() {
            var mapOptions = {
                center: new naver.maps.LatLng(this.lat, this.lng),
                zoom: 10,
                zoomControl: true,
                zoomControlOptions: { //줌 컨트롤의 옵션
                    position: naver.maps.Position.TOP_LEFT
                },
                draggable: false,
            };
            var map = new naver.maps.Map('map', mapOptions);

            naver.maps.Service.geocode({query: this.baseInfo.addr1}, function (status, response) {
                if (status === naver.maps.Service.Status.ERROR) {
                    return alert('Something wrong!');
                }

                var item = response.v2.addresses[0],
                point = new naver.maps.Point(item.x, item.y);
                map.setCenter(point);

                // 마커
                var marker = new naver.maps.Marker({
                    position: new naver.maps.LatLng(item.y, item.x),
                    map: map,
                    icon: {
                        content: [
                            '<div style="background-color: white;">마커마커</div>'
                        ].join(''),
                        size: new naver.maps.Size(38,38),
                        anchor: new naver.maps.Point(19.58),
                    }
                });

                naver.maps.Event.addListener(marker, 'click', function(e){
                    map.panTo(point);
                });

            });
        }
    }
}
</script>